<template>
  <div class="page flex-col">
    <!-- 顶部导航 -->
    <div class="header">
      <div class="header-left" @click="goBack">
        <span class="back-arrow">←</span>
        <span class="title">系统管理</span>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="content">
      <!-- 全站新增统计：仅 SuperAdmin 可见，后端接口强制鉴权 -->
      <div class="module-card" v-if="isSuperAdmin">
        <div class="module-header" @click="toggleModule('platformGrowth')">
          <h3 class="module-title">
            <i class="icon" :class="modules.platformGrowth.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            全站新增
          </h3>
        </div>
        <div v-show="modules.platformGrowth.expanded" class="module-content">
          <div class="site-info">
            <div class="info-item">
              <span class="label">今日新增用户</span>
              <span class="value today-value">{{ siteGrowth.today_users || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">今日新增任务</span>
              <span class="value today-value">{{ siteGrowth.today_tasks || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">近7天新增用户</span>
              <span class="value">{{ siteGrowth.week_users || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">近7天新增任务</span>
              <span class="value">{{ siteGrowth.week_tasks || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">累计用户</span>
              <span class="value">{{ siteGrowth.total_users || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">累计任务</span>
              <span class="value">{{ siteGrowth.total_tasks || 0 }}</span>
            </div>
          </div>
          <p style="margin:10px 0 0;font-size:12px;color:#8a8f99;">统计口径：全部站点合计 {{ siteGrowth.day || '' }}</p>
        </div>
      </div>
      <!-- 站点信息模块 -->
      <div class="module-card">
        <div class="module-header" @click="toggleModule('siteInfo')">
          <h3 class="module-title">
            <i class="icon" :class="modules.siteInfo.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            站点信息
          </h3>
        </div>
        <div v-show="modules.siteInfo.expanded" class="module-content">
          <div class="site-info">
            <div class="info-item">
              <span class="label">站点</span>
              <span class="value">{{ siteInfo.site_name || '加载中...' }}</span>
            </div>
            <div class="info-item">
              <span class="label">注册人数</span>
              <span class="value">{{ siteInfo.count_user || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">任务数量</span>
              <span class="value">{{ siteInfo.count_task || 0 }}</span>
            </div>
            <div class="info-item">
              <span class="label">累计充值</span>
              <span class="value">{{ siteInfo.total_recharge || 0 }}</span>
            </div>
            <div class="info-item today-item">
              <span class="label">今日注册</span>
              <span class="value today-value">{{ siteInfo.today_user || 0 }}</span>
            </div>
            <div class="info-item today-item">
              <span class="label">今日任务</span>
              <span class="value today-value">{{ siteInfo.today_task || 0 }}</span>
            </div>
            <div class="info-item today-item">
              <span class="label">今日收入</span>
              <span class="value today-value">{{ siteInfo.today_income || 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 用户管理模块 -->
      <div class="module-card">
        <div class="module-header" @click="toggleModule('userManagement')">
          <h3 class="module-title">
            <i class="icon" :class="modules.userManagement.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            用户管理
          </h3>
        </div>
        <div v-show="modules.userManagement.expanded" class="module-content">
          <div class="search-bar">
            <input
              v-model="userSearch"
              @input="searchUsers"
              placeholder="搜索用户名"
              class="search-input"
            />
            <span class="user-count">共{{ userList.total_nums || 0 }}人</span>
          </div>

          <div class="user-list">
            <div
              v-for="user in userList.list"
              :key="user.uuid"
              class="user-item"
            >
              <div class="user-info">
                <span class="username">{{ user.username }}</span>
                <span class="balance">积分: {{ user.balance || 0 }}</span>
              </div>
              <div class="user-actions" v-if="isAdmin">
                <button @click="editUserBalance(user)" class="edit-btn" v-if="isSuperAdmin">修改积分</button>
                <button @click="resetUserPassword(user)" class="reset-btn">重置密码</button>
              </div>
            </div>
          </div>

          <div class="pagination" v-if="userList.total_page > 1">
            <button
              @click="prevUserPage"
              :disabled="currentUserPage <= 1"
              class="page-btn"
            >上一页</button>
            <span class="page-info">{{ currentUserPage }}/{{ userList.total_page }}</span>
            <button
              @click="nextUserPage"
              :disabled="currentUserPage >= userList.total_page"
              class="page-btn"
            >下一页</button>
          </div>
        </div>
      </div>

      <!-- 任务管理模块 -->
      <div class="module-card">
        <div class="module-header" @click="toggleModule('taskManagement')">
          <h3 class="module-title">
            <i class="icon" :class="modules.taskManagement.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            任务管理
          </h3>
        </div>
        <div v-show="modules.taskManagement.expanded" class="module-content">
          <div class="search-bar">
            <input
              v-model="taskSearch"
              @input="searchTasks"
              placeholder="搜索姓名或手机号"
              class="search-input"
            />
            <span class="task-count">共{{ taskList.total_nums || 0 }}个任务</span>
          </div>

          <div class="task-list">
            <div
              v-for="task in taskList.list"
              :key="task.bind_uuid"
              class="task-item"
            >
              <div class="task-info">
                <div class="task-name">{{ task.nikeName }}</div>
                <div class="task-phone">{{ task.phone }}</div>
                <div class="task-bind">绑定账户: {{ task.bind_username || '未知' }}</div>
                <div class="task-site">所属网站: {{ task.site_host || '未关联网站' }}</div>
                <div class="task-days">签到日期: {{ task.SignDayEable }}</div>
                <div class="task-vip">VIP到期: {{ task.vip_sign_end_time }}</div>
              </div>
              <div class="task-actions">
                <button @click="editTask(task)" class="edit-btn">编辑</button>
                <button @click="deleteTask(task)" class="delete-btn">删除</button>
              </div>
            </div>
          </div>

          <div class="pagination" v-if="taskList.total_page > 1">
            <button
              @click="prevTaskPage"
              :disabled="currentTaskPage <= 1"
              class="page-btn"
            >上一页</button>
            <span class="page-info">{{ currentTaskPage }}/{{ taskList.total_page }}</span>
            <button
              @click="nextTaskPage"
              :disabled="currentTaskPage >= taskList.total_page"
              class="page-btn"
            >下一页</button>
          </div>
        </div>
      </div>

      <!-- 充值记录模块 -->
      <div class="module-card">
        <div class="module-header" @click="toggleModule('rechargeManagement')">
          <h3 class="module-title">
            <i class="icon" :class="modules.rechargeManagement.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            充值记录
          </h3>
        </div>
        <div v-show="modules.rechargeManagement.expanded" class="module-content">
          <div class="search-bar">
            <input
              v-model="rechargeSearch"
              @input="searchRecharges"
              placeholder="搜索用户名"
              class="search-input"
            />
            <span class="recharge-count">共{{ rechargeList.total_nums || 0 }}条记录</span>
          </div>

          <div class="recharge-list">
            <div
              v-for="record in rechargeList.list"
              :key="record.id"
              class="recharge-item"
            >
              <div class="recharge-info">
                <div class="recharge-user">用户: {{ record.username }}</div>
                <div class="recharge-amount">金额: ¥{{ record.total_fee }}</div>
                <div class="recharge-time">时间: {{ record.create_time }}</div>
                <div class="recharge-status">状态: {{ getPayStatus(record.status) }}</div>
              </div>
            </div>
          </div>

          <div class="pagination" v-if="rechargeList.total_page > 1">
            <button
              @click="prevRechargePage"
              :disabled="currentRechargePage <= 1"
              class="page-btn"
            >上一页</button>
            <span class="page-info">{{ currentRechargePage }}/{{ rechargeList.total_page }}</span>
            <button
              @click="nextRechargePage"
              :disabled="currentRechargePage >= rechargeList.total_page"
              class="page-btn"
            >下一页</button>
          </div>
        </div>
      </div>

      <!-- 今日有收入站点：仅 SuperAdmin 可见，后端接口也会强制鉴权 -->
      <div class="module-card" v-if="isSuperAdmin">
        <div class="module-header" @click="toggleModule('todaySiteIncome')">
          <h3 class="module-title">
            <i class="icon" :class="modules.todaySiteIncome.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            今日有收入站点
          </h3>
        </div>
        <div v-show="modules.todaySiteIncome.expanded" class="module-content site-income-content">
          <div class="site-income-summary">
            <div>
              <span>今日收入</span>
              <strong>¥{{ formatAmount(todaySiteIncome.total_amount) }}</strong>
            </div>
            <em>{{ todaySiteIncome.total_sites || 0 }} 个站点 · {{ todaySiteIncome.total_orders || 0 }} 笔</em>
          </div>
          <div v-if="todaySiteIncome.sites.length" class="site-income-list">
            <div v-for="site in todaySiteIncome.sites" :key="site.site_host" class="site-income-row">
              <span class="site-income-host">{{ site.site_host }}</span>
              <span class="site-income-orders">{{ site.order_count }} 笔</span>
              <strong>¥{{ formatAmount(site.amount) }}</strong>
            </div>
          </div>
          <div v-else class="site-income-empty">今日暂无收入站点</div>
        </div>
      </div>

      <!-- 支付统计模块：仅 SuperAdmin 可见，后端接口也会强制鉴权 -->
      <div class="module-card" v-if="isSuperAdmin">
        <div class="module-header" @click="toggleModule('paymentStatistics')">
          <h3 class="module-title">
            <i class="icon" :class="modules.paymentStatistics.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            支付统计
          </h3>
        </div>
        <div v-show="modules.paymentStatistics.expanded" class="module-content payment-statistics-content">
          <div class="payment-statistics-caption">
            实际收款按支付成功入账统计，数据从 {{ paymentStats.tracking_started_at || '今日' }} 开始记录。
          </div>
          <div class="payment-statistics-total">
            <span>今日实际收款</span>
            <strong>¥{{ formatAmount(paymentStats.today_receipts.total_amount) }}</strong>
            <em>{{ paymentStats.today_receipts.total_orders || 0 }} 笔</em>
          </div>
          <div class="payment-statistics-table">
            <div class="payment-statistics-row payment-statistics-heading">
              <span>方式</span>
              <span>成功笔数</span>
              <span>实收金额</span>
              <span>金额占比</span>
            </div>
            <div class="payment-statistics-row">
              <span>支付宝</span>
              <span>{{ paymentStats.today_receipts.alipay.orders || 0 }}</span>
              <span>¥{{ formatAmount(paymentStats.today_receipts.alipay.amount) }}</span>
              <span>{{ paymentStats.today_receipts.alipay.amount_share || 0 }}%</span>
            </div>
            <div class="payment-statistics-row">
              <span>微信</span>
              <span>{{ paymentStats.today_receipts.wechat.orders || 0 }}</span>
              <span>¥{{ formatAmount(paymentStats.today_receipts.wechat.amount) }}</span>
              <span>{{ paymentStats.today_receipts.wechat.amount_share || 0 }}%</span>
            </div>
          </div>

          <div class="payment-statistics-subtitle">近 30 天实际收款</div>
          <div class="payment-statistics-table daily-payment-list">
            <div class="payment-statistics-row payment-statistics-heading">
              <span>日期</span>
              <span>支付宝</span>
              <span>微信</span>
              <span>合计</span>
            </div>
            <div v-for="day in paymentStats.daily_receipts" :key="day.day" class="payment-statistics-row">
              <span>{{ day.day }}</span>
              <span>¥{{ formatAmount(day.alipay.amount) }}</span>
              <span>¥{{ formatAmount(day.wechat.amount) }}</span>
              <span>¥{{ formatAmount(day.total_amount) }}</span>
            </div>
          </div>

          <div class="payment-statistics-subtitle">历史已提交支付订单占比</div>
          <div class="payment-statistics-table">
            <div class="payment-statistics-row payment-statistics-heading">
              <span>方式</span>
              <span>订单数</span>
              <span>订单占比</span>
              <span>说明</span>
            </div>
            <div class="payment-statistics-row">
              <span>支付宝</span>
              <span>{{ paymentStats.submitted_order_ratio.alipay.orders || 0 }}</span>
              <span>{{ paymentStats.submitted_order_ratio.alipay.order_share || 0 }}%</span>
              <span>创建订单</span>
            </div>
            <div class="payment-statistics-row">
              <span>微信</span>
              <span>{{ paymentStats.submitted_order_ratio.wechat.orders || 0 }}</span>
              <span>{{ paymentStats.submitted_order_ratio.wechat.order_share || 0 }}%</span>
              <span>创建订单</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 登录公告设置模块 -->
      <div class="module-card">
        <div class="module-header" @click="toggleModule('noticeSettings')">
          <h3 class="module-title">
            <i class="icon" :class="modules.noticeSettings.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            登录公告设置
          </h3>
        </div>
        <div v-show="modules.noticeSettings.expanded" class="module-content">
          <div class="settings-form">
            <div class="input-group">
              <label class="input-label">
                <i class="label-icon">📢</i>
                公告内容
              </label>
              <textarea
                v-model="loginNotice"
                placeholder="请输入登录公告内容，用户登录时会弹窗显示"
                class="modern-textarea"
                rows="4"
              ></textarea>
              <div class="input-hint">设置后用户登录时会自动弹窗显示</div>
            </div>
            <div class="settings-actions">
              <button @click="saveLoginNotice" class="modern-btn save-btn">
                <i class="btn-icon">💾</i>
                保存公告
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 客服QQ设置模块 -->
      <div class="module-card">
        <div class="module-header" @click="toggleModule('qqSettings')">
          <h3 class="module-title">
            <i class="icon" :class="modules.qqSettings.expanded ? 'icon-expanded' : 'icon-collapsed'"></i>
            客服QQ设置
          </h3>
        </div>
        <div v-show="modules.qqSettings.expanded" class="module-content">
          <div class="settings-form">
            <div class="input-group">
              <label class="input-label">
                <i class="label-icon">💬</i>
                客服QQ号
              </label>
              <input
                v-model="customerQQ"
                placeholder="请输入客服QQ号，如：3842705664"
                class="modern-input"
                type="number"
              />
              <div class="input-hint">设置后会显示在联系客服的位置</div>
            </div>
            <div class="settings-actions">
              <button @click="saveCustomerQQ" class="modern-btn save-btn">
                <i class="btn-icon">💾</i>
                保存QQ号
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改积分弹窗 -->
    <div v-if="showBalanceModal" class="modal-overlay" @click="closeBalanceModal">
      <div class="modal-content modern-modal" @click.stop>
        <div class="modal-header">
          <div class="modal-icon balance-icon">💰</div>
          <h3 class="modal-title">修改用户积分</h3>
          <button @click="closeBalanceModal" class="modal-close">×</button>
        </div>
        <div class="modal-body">
          <div class="user-info-card">
            <div class="info-row">
              <span class="info-label">用户名</span>
              <span class="info-value">{{ editingUser.username }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">当前积分</span>
              <span class="info-value current-balance">{{ editingUser.balance }}</span>
            </div>
          </div>
          <div class="input-group">
            <label class="input-label">新积分数量</label>
            <input
              v-model="newBalance"
              type="number"
              placeholder="请输入新的积分"
              class="modern-input"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeBalanceModal" class="modern-btn cancel-btn">取消</button>
          <button @click="confirmEditBalance" class="modern-btn confirm-btn">确定修改</button>
        </div>
      </div>
    </div>

    <!-- 编辑任务弹窗 -->
    <div v-if="showTaskModal" class="modal-overlay" @click="closeTaskModal">
      <div class="modal-content modern-modal task-modal" @click.stop>
        <div class="modal-header">
          <div class="modal-icon task-icon">📋</div>
          <h3 class="modal-title">编辑任务信息</h3>
          <button @click="closeTaskModal" class="modal-close">×</button>
        </div>
        <div class="modal-body compact">
          <div class="user-info-card compact">
            <div class="info-row">
              <span class="info-label">手机号</span>
              <span class="info-value">{{ editingTask.phone }}</span>
            </div>
          </div>
          <div class="form-compact">
            <div class="input-group compact">
              <label class="input-label compact">
                <i class="label-icon">👤</i>
                姓名
              </label>
              <input
                v-model="taskForm.nikeName"
                placeholder="请输入姓名"
                class="modern-input compact"
              />
            </div>
            <div class="input-group compact">
              <label class="input-label compact">
                <i class="label-icon">📅</i>
                签到日期
              </label>
              <input
                v-model="taskForm.SignDayEable"
                placeholder="1,2,3,4,5,6,7"
                class="modern-input compact"
              />
              <div class="input-hint compact">1-7代表周一到周日</div>
            </div>
            <div class="input-group compact">
              <label class="input-label compact">
                <i class="label-icon">⏰</i>
                VIP到期时间
              </label>
              <input
                v-model="taskForm.vip_sign_end_time"
                type="datetime-local"
                class="modern-input compact"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer compact">
          <button @click="closeTaskModal" class="modern-btn cancel-btn compact">取消</button>
          <button @click="confirmEditTask" class="modern-btn confirm-btn compact">保存</button>
        </div>
      </div>
    </div>

    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>

<script>
import axios from 'axios'
import { Toast } from 'vant'
import { API_ENDPOINTS } from '@/config/api'
import BottomNavigation from '@/components/BottomNavigation.vue'

export default {
  name: 'SystemManagement',
  components: {
    BottomNavigation
  },
  data() {
    return {
      // 站点信息
      siteInfo: {},
      
      // 用户管理
      userList: { list: [], total_nums: 0, total_page: 0 },
      userSearch: '',
      currentUserPage: 1,
      
      // 任务管理
      taskList: { list: [], total_nums: 0, total_page: 0 },
      taskSearch: '',
      currentTaskPage: 1,
      
      // 充值记录
      rechargeList: { list: [], total_nums: 0, total_page: 0 },
      rechargeSearch: '',
      currentRechargePage: 1,

      // 支付统计（全站聚合；仅 SuperAdmin 会发起请求）
      paymentStats: {
        tracking_started_at: '',
        today_receipts: {
          total_amount: 0,
          total_orders: 0,
          alipay: { orders: 0, amount: 0, amount_share: 0 },
          wechat: { orders: 0, amount: 0, amount_share: 0 }
        },
        daily_receipts: [],
        submitted_order_ratio: {
          alipay: { orders: 0, order_share: 0 },
          wechat: { orders: 0, order_share: 0 }
        }
      },

      // 今日有收入的真实付款来源站点（仅 SuperAdmin 会发起请求）
      todaySiteIncome: {
        day: '',
        total_sites: 0,
        total_orders: 0,
        total_amount: 0,
        sites: []
      },
      
      // 设置
      loginNotice: '',
      customerQQ: '',
      siteGrowth: {},
      
      // 权限控制
      canEditBalance: false,
      isAdmin: false,
      isSuperAdmin: false,
      currentUserInfo: {},

      // 模块展开状态
      modules: {
        platformGrowth: { expanded: true },
        siteInfo: { expanded: false },
        userManagement: { expanded: false },
        taskManagement: { expanded: false },
        rechargeManagement: { expanded: false },
        todaySiteIncome: { expanded: false },
        paymentStatistics: { expanded: false },
        noticeSettings: { expanded: false },
        qqSettings: { expanded: false }
      },

      // 弹窗
      showBalanceModal: false,
      editingUser: {},
      newBalance: '',

      // 任务编辑弹窗
      showTaskModal: false,
      editingTask: {},
      taskForm: {
        nikeName: '',
        SignDayEable: '',
        vip_sign_end_time: ''
      }
    };
  },
  async mounted() {
    await this.checkPermission();
    if (this.hasPermission) {
      await this.loadAllData();
    }
  },
  methods: {
    showToast(message) {
      Toast(message);
    },
    
    // 权限检查
    async checkPermission() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        const res = await axios.get(API_ENDPOINTS.USER.INFO, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (res.data.code === 0) {
          const userInfo = res.data.data;
          this.currentUserInfo = userInfo;
          this.hasPermission = userInfo.is_admin;
          this.isAdmin = userInfo.is_admin;
          // 由后端返回窄权限标识；界面隐藏不替代统计接口的后端校验。
          this.isSuperAdmin = Boolean(userInfo.can_view_payment_statistics);
          this.canEditBalance = this.isSuperAdmin;
          
          if (!this.hasPermission) {
            this.showToast('权限不足');
            this.$router.push('/lanhu_wode');
            return;
          }
        } else {
          this.showToast('获取用户信息失败');
          this.$router.push('/lanhu_yonghudenglu');
        }
      } catch (error) {
        console.error('权限检查失败:', error);
        this.$router.push('/lanhu_yonghudenglu');
      }
    },

    // 切换模块展开状态
    toggleModule(moduleName) {
      this.modules[moduleName].expanded = !this.modules[moduleName].expanded;
    },

    // 加载所有数据
    async loadAllData() {
      const loaders = [
        this.loadSiteInfo(),
        this.loadUsers(),
        this.loadTasks(),
        this.loadRecharges(),
        this.loadSettings()
      ];
      if (this.isSuperAdmin) {
        loaders.push(this.loadTodaySiteIncome());
        loaders.push(this.loadPaymentStatistics());
        loaders.push(this.loadSiteGrowth());
      }
      await Promise.all(loaders);
    },

    // 全站新增统计(仅 SuperAdmin)
    async loadSiteGrowth() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(API_ENDPOINTS.MANAGER.GET_SITE_GROWTH, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.data.code === 0 && res.data.data) {
          this.siteGrowth = res.data.data;
        }
      } catch (error) {
        console.error('加载全站新增统计失败:', error);
      }
    },

    // 加载站点信息
    async loadSiteInfo() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.GXY.GET_SITE_INFO, {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.siteInfo = res.data.data;
        }
      } catch (error) {
        console.error('加载站点信息失败:', error);
      }
    },

    // 加载用户列表
    async loadUsers() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.GET_ALL_USERS, {
          page: this.currentUserPage,
          search: this.userSearch
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.userList = res.data.data;
        }
      } catch (error) {
        console.error('加载用户列表失败:', error);
      }
    },

    // 加载任务列表
    async loadTasks() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.GET_ALL_TASKS, {
          page: this.currentTaskPage,
          search: this.taskSearch
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.taskList = res.data.data;
        }
      } catch (error) {
        console.error('加载任务列表失败:', error);
      }
    },

    // 加载充值记录
    async loadRecharges() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.GET_ALL_PAYS, {
          page: this.currentRechargePage,
          search: this.rechargeSearch
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.rechargeList = res.data.data;
        }
      } catch (error) {
        console.error('加载充值记录失败:', error);
      }
    },

    // 仅 SuperAdmin 请求全站支付方式与实际收款聚合数据。
    async loadPaymentStatistics() {
      if (!this.isSuperAdmin) return;
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.GET_PAYMENT_STATISTICS, {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (res.data.code === 0) {
          this.paymentStats = res.data.data;
        }
      } catch (error) {
        console.error('加载支付统计失败:', error);
      }
    },

    // 仅 SuperAdmin 请求当天正收入站点聚合数据。
    async loadTodaySiteIncome() {
      if (!this.isSuperAdmin) return;
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.GET_TODAY_SITE_INCOME, {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (res.data.code === 0) {
          this.todaySiteIncome = res.data.data;
        }
      } catch (error) {
        console.error('加载今日站点收入失败:', error);
      }
    },

    // 加载设置
    async loadSettings() {
      try {
        const token = localStorage.getItem('token');

        // 加载登录公告
        const noticeRes = await axios.post(API_ENDPOINTS.SETTING.GET_SETTING, {
          key: 'login_notice'
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (noticeRes.data.code === 0) {
          this.loginNotice = noticeRes.data.data || '';
        }

        // 加载客服QQ
        const qqRes = await axios.post(API_ENDPOINTS.SETTING.GET_SETTING, {
          key: 'qq'
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (qqRes.data.code === 0) {
          this.customerQQ = qqRes.data.data || '';
        }
      } catch (error) {
        console.error('加载设置失败:', error);
      }
    },

    // 搜索用户
    searchUsers() {
      this.currentUserPage = 1;
      this.loadUsers();
    },

    // 搜索任务
    searchTasks() {
      this.currentTaskPage = 1;
      this.loadTasks();
    },

    // 搜索充值记录
    searchRecharges() {
      this.currentRechargePage = 1;
      this.loadRecharges();
    },

    // 用户分页
    prevUserPage() {
      if (this.currentUserPage > 1) {
        this.currentUserPage--;
        this.loadUsers();
      }
    },

    nextUserPage() {
      if (this.currentUserPage < this.userList.total_page) {
        this.currentUserPage++;
        this.loadUsers();
      }
    },

    // 任务分页
    prevTaskPage() {
      if (this.currentTaskPage > 1) {
        this.currentTaskPage--;
        this.loadTasks();
      }
    },

    nextTaskPage() {
      if (this.currentTaskPage < this.taskList.total_page) {
        this.currentTaskPage++;
        this.loadTasks();
      }
    },

    // 充值记录分页
    prevRechargePage() {
      if (this.currentRechargePage > 1) {
        this.currentRechargePage--;
        this.loadRecharges();
      }
    },

    nextRechargePage() {
      if (this.currentRechargePage < this.rechargeList.total_page) {
        this.currentRechargePage++;
        this.loadRecharges();
      }
    },

    // 修改用户积分
    editUserBalance(user) {
      this.editingUser = user;
      this.newBalance = user.balance;
      this.showBalanceModal = true;
    },

    // 重置用户密码
    async resetUserPassword(user) {
      try {
        const confirmed = confirm(`确定要重置用户 "${user.username}" 的密码吗？\n重置后密码将变为：abcd1234`);
        if (!confirmed) {
          return;
        }

        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.RESET_PASSWORD, {
          uuid: user.uuid
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.showToast('重置成功，新密码为：abcd1234');
        } else {
          this.showToast(res.data.message || '重置失败');
        }
      } catch (error) {
        console.error('重置密码失败:', error);
        this.showToast('重置失败，请稍后重试');
      }
    },

    closeBalanceModal() {
      this.showBalanceModal = false;
      this.editingUser = {};
      this.newBalance = '';
    },

    async confirmEditBalance() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.EDIT_BALANCE, {
          uuid: this.editingUser.uuid,
          balance: parseFloat(this.newBalance)
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.showToast('积分修改成功');
          this.closeBalanceModal();
          this.loadUsers();
        } else {
          this.showToast(res.data.message || '积分修改失败');
        }
      } catch (error) {
        console.error('修改积分失败:', error);
        this.showToast('积分修改失败');
      }
    },

    // 保存登录公告
    async saveLoginNotice() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.SETTING.SET_SETTING, {
          key: 'login_notice',
          value: this.loginNotice
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.showToast('登录公告保存成功');
        } else {
          this.showToast(res.data.message || '保存失败');
        }
      } catch (error) {
        console.error('保存登录公告失败:', error);
        this.showToast('保存失败');
      }
    },

    // 保存客服QQ
    async saveCustomerQQ() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.SETTING.SET_SETTING, {
          key: 'qq',
          value: this.customerQQ
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.showToast('客服QQ保存成功');
        } else {
          this.showToast(res.data.message || '保存失败');
        }
      } catch (error) {
        console.error('保存客服QQ失败:', error);
        this.showToast('保存失败');
      }
    },

    // 获取支付状态文本
    getPayStatus(status) {
      const statusMap = {
        0: '待支付',
        1: '支付中',
        2: '已支付',
        3: '支付失败'
      };
      return statusMap[status] || '未知状态';
    },

    formatAmount(value) {
      const amount = Number(value || 0);
      return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
    },

    // 编辑任务
    editTask(task) {
      this.editingTask = task;
      this.taskForm = {
        nikeName: task.nikeName,
        SignDayEable: task.SignDayEable,
        vip_sign_end_time: task.vip_sign_end_time
      };
      this.showTaskModal = true;
    },

    closeTaskModal() {
      this.showTaskModal = false;
      this.editingTask = {};
      this.taskForm = {
        nikeName: '',
        SignDayEable: '',
        vip_sign_end_time: ''
      };
    },

    async confirmEditTask() {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.EDIT_TASK, {
          phone: this.editingTask.phone,
          nikeName: this.taskForm.nikeName,
          SignDayEable: this.taskForm.SignDayEable,
          vip_sign_end_time: this.taskForm.vip_sign_end_time
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.showToast('任务信息修改成功');
          this.closeTaskModal();
          this.loadTasks();
        } else {
          this.showToast(res.data.message || '任务信息修改失败');
        }
      } catch (error) {
        console.error('修改任务信息失败:', error);
        this.showToast('任务信息修改失败');
      }
    },

    // 删除任务
    async deleteTask(task) {
      try {
        const confirmed = confirm(`确定要删除任务 ${task.nikeName}(${task.phone}) 吗？`);
        if (!confirmed) return;

        const token = localStorage.getItem('token');
        const res = await axios.post(API_ENDPOINTS.MANAGER.DELETE_TASK, {
          phone: task.phone
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (res.data.code === 0) {
          this.showToast('任务删除成功');
          this.loadTasks();
        } else {
          this.showToast(res.data.message || '任务删除失败');
        }
      } catch (error) {
        console.error('删除任务失败:', error);
        this.showToast('任务删除失败');
      }
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
/* 通用flex布局类 */
.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-between {
  display: flex;
  justify-content: space-between;
}

.align-center {
  display: flex;
  align-items: center;
}

.page {
  background-color: rgba(247, 247, 247, 1);
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  margin: 0 auto;
  padding-bottom: 80px; /* 为底部导航栏留出空间 */
  font-family: PingFangSC-Regular, Source Han Sans CN-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma, Arial, Microsoft YaHei;
}

/* 顶部导航 */
.header {
  background: rgba(255, 255, 255, 1);
  padding: 15px 20px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.header-left:hover {
  opacity: 0.8;
}

.back-arrow {
  font-size: 18px;
  margin-right: 8px;
  color: rgba(0, 203, 106, 1);
  font-weight: bold;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  font-family: Source Han Sans CN-Bold;
}

/* 内容区域 */
.content {
  padding: 15px 20px;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

/* 模块卡片 */
.module-card {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(240, 240, 240, 1);
  overflow: hidden;
  transition: all 0.2s ease;
}

.module-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* 模块头部 */
.module-header {
  padding: 15px 20px;
  cursor: pointer;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  transition: all 0.2s ease;
  background: rgba(0, 203, 106, 0.02);
}

.module-header:hover {
  background: rgba(0, 203, 106, 0.05);
}

.module-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  margin: 0;
  display: flex;
  align-items: center;
  font-family: Source Han Sans CN-Bold;
}

/* 展开/折叠图标 */
.icon {
  margin-right: 8px;
  transition: transform 0.3s ease;
  font-style: normal;
  font-size: 12px;
  color: rgba(0, 203, 106, 1);
}

.icon-collapsed::before {
  content: '▶';
}

.icon-expanded::before {
  content: '▼';
}

.icon-expanded {
  transform: rotate(0deg);
}

/* 模块内容 */
.module-content {
  padding: 20px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 站点信息 */
.site-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: rgba(248, 249, 250, 1);
  border-radius: 6px;
  border-left: 3px solid rgba(0, 203, 106, 1);
  transition: all 0.2s ease;
}

.info-item:hover {
  background: rgba(0, 203, 106, 0.05);
}

/* 今日数据特殊样式 */
.today-item {
  border-left: 3px solid rgba(255, 165, 0, 1) !important;
  background: rgba(255, 165, 0, 0.05) !important;
}

.today-item:hover {
  background: rgba(255, 165, 0, 0.1) !important;
}

.today-value {
  color: rgba(255, 140, 0, 1) !important;
  font-weight: 700 !important;
}

.label {
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  font-size: 13px;
  font-family: Source Han Sans CN-Regular;
}

.value {
  color: rgba(0, 203, 106, 1);
  font-weight: 600;
  font-size: 14px;
  font-family: Source Han Sans CN-Bold;
}

/* 搜索栏 */
.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 12px 15px;
  background: rgba(0, 203, 106, 0.05);
  border-radius: 6px;
  border: 1px solid rgba(0, 203, 106, 0.1);
}

.search-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid rgba(0, 203, 106, 0.2);
  border-radius: 15px;
  margin-right: 12px;
  font-size: 13px;
  transition: all 0.2s ease;
  background: white;
  font-family: Source Han Sans CN-Regular;
}

.search-input:focus {
  outline: none;
  border-color: rgba(0, 203, 106, 1);
  box-shadow: 0 0 0 2px rgba(0, 203, 106, 0.1);
}

.user-count,
.task-count,
.recharge-count {
  color: rgba(0, 203, 106, 1);
  font-size: 12px;
  font-weight: 600;
  background: white;
  padding: 5px 10px;
  border-radius: 12px;
  border: 1px solid rgba(0, 203, 106, 0.2);
  font-family: Source Han Sans CN-Regular;
}

/* 列表项 */
.user-item,
.task-item,
.recharge-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border: 1px solid rgba(240, 240, 240, 1);
  border-radius: 6px;
  margin-bottom: 8px;
  background: white;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.user-item:hover,
.task-item:hover,
.recharge-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-color: rgba(0, 203, 106, 0.3);
}

.user-info,
.task-info,
.recharge-info {
  flex: 1;
}

.username {
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  font-size: 14px;
  margin-bottom: 4px;
  font-family: Source Han Sans CN-Bold;
}

.balance {
  color: rgba(0, 203, 106, 1);
  font-size: 12px;
  font-weight: 600;
  background: rgba(0, 203, 106, 0.1);
  padding: 2px 8px;
  border-radius: 8px;
  display: inline-block;
  font-family: Source Han Sans CN-Regular;
}

.task-name {
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  margin-bottom: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN-Bold;
}

.task-phone,
.task-bind,
.task-site,
.task-days,
.task-vip {
  font-size: 12px;
  color: rgba(108, 117, 125, 1);
  margin-bottom: 3px;
  line-height: 1.4;
  font-family: Source Han Sans CN-Regular;
}

.task-bind {
  color: rgba(0, 203, 106, 1);
  font-weight: 500;
}

.task-info {
  min-width: 0;
}

.task-site {
  overflow-wrap: anywhere;
}

.recharge-user {
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  margin-bottom: 6px;
  font-size: 14px;
  font-family: Source Han Sans CN-Bold;
}

.recharge-amount,
.recharge-time,
.recharge-status {
  font-size: 12px;
  color: rgba(108, 117, 125, 1);
  margin-bottom: 3px;
  line-height: 1.4;
  font-family: Source Han Sans CN-Regular;
}

/* 支付统计 */
.payment-statistics-content {
  padding-top: 16px;
}

.payment-statistics-caption {
  color: rgba(108, 117, 125, 1);
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 12px;
}

.payment-statistics-total {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 8px 0 14px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  color: rgba(21, 44, 7, 1);
  font-size: 13px;
}

.payment-statistics-total strong {
  color: rgba(0, 203, 106, 1);
  font-size: 21px;
  font-weight: 700;
}

.payment-statistics-total em {
  color: rgba(108, 117, 125, 1);
  font-size: 12px;
  font-style: normal;
}

.payment-statistics-subtitle {
  color: rgba(21, 44, 7, 1);
  font-size: 13px;
  font-weight: 600;
  margin: 18px 0 8px;
}

.payment-statistics-table {
  border-top: 1px solid rgba(240, 240, 240, 1);
}

.payment-statistics-row {
  display: grid;
  grid-template-columns: minmax(72px, 1.1fr) repeat(3, minmax(0, 1fr));
  gap: 8px;
  align-items: center;
  min-height: 38px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  color: rgba(54, 67, 77, 1);
  font-size: 12px;
}

.payment-statistics-row span:not(:first-child) {
  text-align: right;
}

.payment-statistics-heading {
  color: rgba(108, 117, 125, 1);
  font-size: 11px;
}

.daily-payment-list .payment-statistics-row {
  grid-template-columns: minmax(84px, 1.15fr) repeat(3, minmax(0, 1fr));
}

/* 今日有收入站点 */
.site-income-content {
  padding-top: 16px;
}

.site-income-summary {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  padding: 4px 0 14px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  color: rgba(21, 44, 7, 1);
  font-size: 13px;
}

.site-income-summary div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.site-income-summary strong {
  color: rgba(0, 203, 106, 1);
  font-size: 21px;
}

.site-income-summary em,
.site-income-orders {
  color: rgba(108, 117, 125, 1);
  font-size: 12px;
  font-style: normal;
}

.site-income-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 64px 90px;
  gap: 10px;
  align-items: center;
  min-height: 42px;
  border-bottom: 1px solid rgba(240, 240, 240, 1);
  font-size: 12px;
}

.site-income-host {
  min-width: 0;
  overflow-wrap: anywhere;
  color: rgba(54, 67, 77, 1);
}

.site-income-row strong {
  text-align: right;
  color: rgba(0, 203, 106, 1);
  font-size: 13px;
}

.site-income-empty {
  padding: 24px 0 8px;
  text-align: center;
  color: rgba(108, 117, 125, 1);
  font-size: 12px;
}

/* 按钮 */
.edit-btn,
.delete-btn,
.save-btn,
.page-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  margin-right: 6px;
  transition: all 0.2s ease;
  font-family: Source Han Sans CN-Regular;
}

.edit-btn {
  background: rgba(0, 203, 106, 1);
  color: white;
  box-shadow: 0 1px 3px rgba(0, 203, 106, 0.3);
}

.edit-btn:hover {
  background: rgba(0, 183, 96, 1);
  box-shadow: 0 2px 6px rgba(0, 203, 106, 0.4);
}

.reset-btn {
  background: linear-gradient(135deg, #ff9800 0%, #ff6f00 100%);
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3);
}

.reset-btn:hover {
  background: linear-gradient(135deg, #ff6f00 0%, #e65100 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.delete-btn {
  background: rgba(255, 77, 79, 1);
  color: white;
  box-shadow: 0 1px 3px rgba(255, 77, 79, 0.3);
}

.delete-btn:hover {
  background: rgba(235, 57, 59, 1);
  box-shadow: 0 2px 6px rgba(255, 77, 79, 0.4);
}

.save-btn {
  background: rgba(0, 203, 106, 1);
  color: white;
  margin-top: 12px;
  padding: 8px 16px;
  box-shadow: 0 1px 3px rgba(0, 203, 106, 0.3);
}

.save-btn:hover {
  background: rgba(0, 183, 96, 1);
  box-shadow: 0 2px 6px rgba(0, 203, 106, 0.4);
}

.page-btn {
  background: rgba(190, 190, 190, 1);
  color: white;
  margin: 0 4px;
  padding: 5px 10px;
  font-size: 11px;
}

.page-btn:hover:not(:disabled) {
  background: rgba(170, 170, 170, 1);
  box-shadow: 0 1px 4px rgba(190, 190, 190, 0.4);
}

.page-btn:disabled {
  background: rgba(220, 220, 220, 1);
  color: rgba(150, 150, 150, 1);
  cursor: not-allowed;
  box-shadow: none;
}

/* 操作按钮容器 */
.user-actions,
.task-actions {
  display: flex;
  gap: 6px;
  align-items: center;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.page-info {
  margin: 0 10px;
  color: #666;
}

/* 旧样式已移除，使用统一的现代化样式 */

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: white;
  border-radius: 8px;
  min-width: 300px;
  max-width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.2s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modern-modal {
  border: 1px solid rgba(240, 240, 240, 1);
}

.task-modal {
  min-width: 350px;
  max-width: 380px;
}

/* 弹窗头部 */
.modal-header {
  padding: 15px 18px;
  background: rgba(0, 203, 106, 1);
  color: white;
  display: flex;
  align-items: center;
  position: relative;
}

.modal-icon {
  font-size: 16px;
  margin-right: 10px;
  background: rgba(255, 255, 255, 0.2);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  flex: 1;
  font-family: Source Han Sans CN-Bold;
}

.modal-close {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 16px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* 弹窗主体 */
.modal-body {
  padding: 18px;
  max-height: 55vh;
  overflow-y: auto;
}

.modal-body.compact {
  padding: 15px;
  max-height: 45vh;
}

/* 用户信息卡片 */
.user-info-card {
  background: rgba(248, 249, 250, 1);
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
  border-left: 3px solid rgba(0, 203, 106, 1);
}

.user-info-card.compact {
  padding: 10px;
  margin-bottom: 12px;
  border-radius: 6px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: 600;
  color: rgba(21, 44, 7, 1);
  font-size: 13px;
  font-family: Source Han Sans CN-Regular;
}

.info-value {
  color: rgba(0, 203, 106, 1);
  font-weight: 600;
  font-size: 14px;
  font-family: Source Han Sans CN-Bold;
}

.current-balance {
  background: rgba(0, 203, 106, 0.1);
  color: rgba(0, 203, 106, 1);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 13px;
}

/* 表单网格 */
.form-grid {
  display: grid;
  gap: 15px;
}

.form-compact {
  display: grid;
  gap: 12px;
}

/* 输入组 */
.input-group {
  margin-bottom: 0;
}

.input-group.compact {
  margin-bottom: 0;
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.input-label.compact {
  margin-bottom: 6px;
  font-size: 12px;
}

.label-icon {
  margin-right: 6px;
  font-size: 14px;
}

.modern-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid rgba(240, 240, 240, 1);
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.2s ease;
  background: white;
  box-sizing: border-box;
  font-family: Source Han Sans CN-Regular;
}

.modern-input.compact {
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 6px;
}

.modern-input:focus {
  outline: none;
  border-color: rgba(0, 203, 106, 1);
  background: white;
  box-shadow: 0 0 0 2px rgba(0, 203, 106, 0.1);
}

.input-hint {
  font-size: 11px;
  color: #6c757d;
  margin-top: 4px;
  font-style: italic;
}

.input-hint.compact {
  font-size: 10px;
  margin-top: 3px;
}

/* 设置表单 */
.settings-form {
  max-width: 100%;
}

.settings-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.modern-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid rgba(240, 240, 240, 1);
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.2s ease;
  background: white;
  box-sizing: border-box;
  resize: vertical;
  font-family: Source Han Sans CN-Regular;
  line-height: 1.5;
}

.modern-textarea:focus {
  outline: none;
  border-color: rgba(0, 203, 106, 1);
  background: white;
  box-shadow: 0 0 0 2px rgba(0, 203, 106, 0.1);
}

/* 弹窗底部 */
.modal-footer {
  padding: 15px 18px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer.compact {
  padding: 12px 15px;
  gap: 8px;
}

.modern-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: Source Han Sans CN-Regular;
}

.modern-btn.compact {
  padding: 5px 12px;
  font-size: 11px;
  min-width: 50px;
}

.btn-icon {
  font-size: 12px;
}

.cancel-btn {
  background: rgba(190, 190, 190, 1);
  color: white;
  box-shadow: 0 1px 3px rgba(190, 190, 190, 0.3);
}

.cancel-btn:hover {
  background: rgba(170, 170, 170, 1);
  box-shadow: 0 2px 6px rgba(190, 190, 190, 0.4);
}

.confirm-btn {
  background: rgba(0, 203, 106, 1);
  color: white;
  box-shadow: 0 1px 3px rgba(0, 203, 106, 0.3);
}

.confirm-btn:hover {
  background: rgba(0, 183, 96, 1);
  box-shadow: 0 2px 6px rgba(0, 203, 106, 0.4);
}

/* 旧版兼容 */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 15px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content {
    padding: 12px 15px;
    max-width: 600px;
  }

  .site-info {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .search-bar {
    flex-direction: column;
    align-items: stretch;
    padding: 10px 12px;
  }

  .search-input {
    margin-right: 0;
    margin-bottom: 8px;
  }

  .user-item,
  .task-item,
  .recharge-item {
    flex-direction: column;
    align-items: stretch;
    padding: 10px 12px;
  }

  .user-actions,
  .task-actions {
    margin-top: 8px;
    justify-content: flex-end;
  }

  .modal-content {
    min-width: 280px;
    margin: 20px;
  }

  .task-modal {
    min-width: 280px;
    max-width: 320px;
  }
}

@media (max-width: 480px) {
  .content {
    max-width: 400px;
    padding: 10px 15px;
  }

  .header {
    padding: 12px 15px;
  }

  .title {
    font-size: 15px;
  }

  .module-header {
    padding: 12px 15px;
  }

  .module-title {
    font-size: 14px;
  }

  .module-content {
    padding: 15px;
  }
}
</style>
